var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-select',{staticClass:"select",attrs:{"options":_vm.audioInputs,"default":_vm.defaultAudioInput,"small":true},on:{"input":function($event){return _vm.settingSelected($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }